import { format } from 'date-fns'

import { ItemHeader } from '@/components/Style/Common'
import type { CompanyVerification } from '@/types/Activity'

import CompanyHouseCheck from './CompanyHouseCheck'
import OrganisationType from './CompanyType'
import { DetailRow } from './OrganisationalDetails'

interface Props {
  verification: CompanyVerification
}

const CorporateVerification: React.FC<Props> = ({
  verification: {
    companyType,
    organisationStatus,
    companyHouseCheck,
    incorporationDate,
    filedAccount,
    companyNumber,
  },
}) => {
  return (
    <div>
      <h4>Confirmed by referencing team</h4>
      <hr />
      <DetailRow>
        <div>
          <ItemHeader>Company Type</ItemHeader>
          <OrganisationType companyType={companyType} />
        </div>
        <div>
          <ItemHeader>Company Status</ItemHeader>
          <p>{organisationStatus}</p>
        </div>
        <div>
          <ItemHeader>Companies House Check</ItemHeader>
          <CompanyHouseCheck companyHouseCheck={companyHouseCheck} />
        </div>
        <div>
          <ItemHeader>Incorporation Date </ItemHeader>
          {incorporationDate ? (
            <p>{format(new Date(incorporationDate), 'dd/MM/yyyy')}</p>
          ) : (
            <p>Unknown</p>
          )}
        </div>
        <div>
          <ItemHeader>Accounts</ItemHeader>
          {filedAccount ? (
            <p>{format(new Date(filedAccount), 'dd/MM/yyyy')}</p>
          ) : (
            <p>N/A</p>
          )}
        </div>
        <div>
          <ItemHeader>Company Number</ItemHeader>
          <p>{companyNumber}</p>
        </div>
      </DetailRow>
    </div>
  )
}

export default CorporateVerification
